import React from 'react';
import {
  KeyboardAwareScrollView as RNKeyboardAwareScrollView,
  KeyboardAwareScrollViewProps,
} from 'react-native-keyboard-aware-scroll-view';
import {withTheme} from '@rneui/themed';

export default withTheme<KeyboardAwareScrollViewProps>(
  RNKeyboardAwareScrollView,
  'KeyboardAwareScrollView',
);

declare module '@rneui/themed' {
  export interface ComponentTheme {
    KeyboardAwareScrollView: Partial<KeyboardAwareScrollViewProps>;
  }
}
